import { render } from "./EntryPaste.vue?vue&type=template&id=7d265986&scoped=true"
import script from "./EntryPaste.vue?vue&type=script&lang=js"
export * from "./EntryPaste.vue?vue&type=script&lang=js"

import "./EntryPaste.vue?vue&type=style&index=0&id=7d265986&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d265986"]])

export default __exports__